import dedent from 'dedent';
import notSet from './notSet';
import isEmail from './isEmail';

export default (val, field, other = {}, runnerId) => {
    if (notSet(val)) {
        return null;
    }

    switch (field) {
        case 'raceName':
            if (val.length < 2) {
                return 'The Race Name should have at least 2 characters';
            }
            break;
        case 'fname':
            if (val.length < 1) {
                return 'Enter a first name with at least 1 characters';
            }
            break;
        case 'lname':
            if (val.length < 1) {
                return 'Enter a last name with at least 1 characters';
            }
            break;
        case 'email':
            if (!isEmail(val)) {
                return 'Double check your email it doesn’t look valid to us';
            }
            if (/\.con$/.test(val)) {
                return 'Looks like you put .con did you mean .com?';
            }
            break;
        case 'password':
            if (runnerId) {
                return null;
            }
            if (val.length < 6) {
                return 'Password must have at least 6 characters';
            }
            break;
        case 'birthday':
            if (val < 18) {
                return 'RUNtrix is only for athletes 18yrs and older';
            }
            if (val > 99) {
                return 'Are you sure you older then 99 years?';
            }
            break;
        case 'zipcode':
            if (!/^[a-zA-Z0-9\-_\s]{1,25}$/.test(val)) {
                return 'Please enter a valid Postal Code';
            }
            break;
        case 'milesweek': {
            const number = Number(val);
            if (!Number.isFinite(number) || number < 0) {
                return 'Enter your weekly volume as a number please.';
            }
            const maxPerWeek = other.units === 'metric' ? 224 : 140;
            const maxDay = maxPerWeek / 7;
            const unit = other.units === 'metric' ? 'km' : 'miles';
            if (number > maxPerWeek) {
                return `Wow, are you really running more than ${maxDay} ${unit} a day?`;
            }
            if (Number(other.runday) === 0 && number > 0) {
                return 'You have your days of running per week at 0. Something isn\'t right.';
            }
            const max = other.units === 'metric' ? 129 : 80;
            if (number > max) {
                return `The maximum allowable weekly volume is ${max} ${other.units === 'metric' ? 'km' : 'miles'}`;
            }
            break;
        }
        case 'lrweek': {
            const number = Number(val);
            const unit = other.units === 'metric' ? 'km' : 'miles';
            if (!Number.isFinite(number) || number < 0) {
                return 'Enter your long run distance as a number please.';
            }
            if (other.milesweek !== '' && Number(other.milesweek) === 0 && number > 0) {
                return `If you are running 0 ${unit} per week, please enter 0 ${unit} for your Long Run.`;
            }
            const max = other.units === 'metric' ? 32 : 20;
            if (number > max) {
                return `The maximum Long Run distance is ${max} ${other.units === 'metric' ? 'km' : 'miles'}`;
            }
            if (other.milesweek && number > Number(other.milesweek)) {
                return 'Your Long Runs are greater than your weekly volume. That doesn’t sound right.';
            }
            const avgrun = Number(other.milesweek / other.runday).toPrecision(2);
            if (other.milesweek && (Number(other.milesweek) / Number(other.runday) > number)) {
                return `Are you sure? This is less than your average daily run (${avgrun} ${unit}).`;
            }
            break;
        }
        case 'yearsrun': {
            if (!/^[0-9]{1,}$/.test(val)) {
                return 'Enter years as a number please.';
            }
            const maxDiff = other.rage - 4;
            if (Number(val) > maxDiff) {
                return `You started young! Based on your age, please enter ${maxDiff} or less.`;
            }
            break;
        }
        case 'runday': {
            if (other.milesweek === '') {
                return null;
            }
            const runday = Number(val);
            const max = other.units === 'metric' ? 19 : 12;
            const unit = other.units === 'metric' ? 'km' : 'miles';
            if (Number(other.milesweek) / runday > max) {
                return dedent`
                    The maximum ${unit} per day is ${max} ${unit}.
                    Please change your ${unit} per week or the number of days of running per week.
                `;
            }
            break;
        }
        default:
    }

    return null;
};



/** WEBPACK FOOTER **
 ** ./src/utils/signupValidator.js
 **/